import React, { useEffect, useState } from "react";
import {
  ModalBody,
  Modal,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import styles from "./addlocationmodal.module.scss";
import Proptypes from "prop-types";
import { addLocation, updateLocation } from "../../../../helpers/service";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";
import Textfield from "../../../Shared/Textfield";
import Button from "../../../Shared/Button";
import {
  setLocations,
  updateLocationReducer,
} from "../../../Redux/Reducer/appReducer";
import { useDispatch, useSelector } from "react-redux";
import { GetCountries, GetState } from "react-country-state-city";
// import { getRandomInt } from "../../../../helpers/utils";

const AddLocationSchema = yup.object().shape({
  name: yup.string().required("Required"),
  brandId: yup.string().required("Required"),
  globalLocationNumber: yup.string().required("Required"),
  addressLineOne: yup.string().required("Required"),

  country: yup.string().required("Required"),
  city: yup.string().required("Required"),
  state: yup.string().required("Required"),
  zipCode: yup.string().required("Required"),
});

const AddLocationModal = ({
  openModal,
  toggle,
  editLocationData,
  setLoading,
}) => {
  const appData = useSelector((state) => state?.appReducer);
  const userData = useSelector((state) => state?.authReducer);
  const [countriesList, setCountriesList] = useState([
    {
      id: 233,
      name: "United States",
      iso3: "USA",
      iso2: "US",
      numeric_code: "840",
      phone_code: "1",
      capital: "Washington",
      currency: "USD",
      currency_name: "United States dollar",
      currency_symbol: "$",
      tld: ".us",
      native: "United States",
      region: "Americas",
      subregion: "Northern America",
      latitude: "38.00000000",
      longitude: "-97.00000000",
      emoji: "🇺🇸",
    },
  ]);
  const [stateList, setStateList] = useState([]);
  const locationData = appData?.locations || [];
  const brandData = appData?.brands || [];
  const brandsFormattedData = (brandData || [])?.map((brandData) => {
    return {
      name: brandData?.brandName,
      id: brandData?.id,
    };
  });
  const [brandsDropdownOpen, setBrandsDropdownOpen] = useState(false);
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [stateDropdown, setStateDropdown] = useState(false);
  const dispatch = useDispatch();

  const initialState = {
    // id: editLocationData.id || '',
    name: editLocationData?.name || "",
    brand: editLocationData?.brand || "",
    globalLocationNumber: editLocationData?.globalLocationNumber || "",
    addressLineOne: editLocationData?.addressLineOne || "",
    addressLineTwo: editLocationData?.addressLineTwo || "",
    country: editLocationData?.country || "United States",
    city: editLocationData?.city || "",
    zipCode: editLocationData?.zipCode || "",
    brandId: editLocationData?.brandId || "",
    state: editLocationData?.state || "",
  };

  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: true,
    validationSchema: AddLocationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    if (editLocationData?.id) {
      try {
        setLoading(true);
        const newData = { ...values, id: editLocationData.id };
        const data = await updateLocation(newData, userData?.idToken);
        dispatch(
          updateLocationReducer({
            updatedLocation: data,
          })
        );
        setLoading(false);
        toast.success("Location updated successfully");

        toggle();
      } catch {
        toast.error("Something went wrong. Please try again.");
        formik.setSubmitting(false);
      }
    } else {
      try {
        setLoading(true);
        const data = await addLocation(values, userData?.idToken);
        const newLocationsData = [...locationData, data];
        dispatch(setLocations(newLocationsData));
        setLoading(false);
        toast.success("Location added successfully");
        formik.resetForm();
        formik.setSubmitting(false);
        toggle();
      } catch {
        toast.error("Something went wrong. Please try again.");
        formik.setSubmitting(false);
      }
    }
  };

  const countryValue =
    formik?.values?.country?.length > 25
      ? formik?.values?.country?.slice(0, 25) + "..."
      : formik?.values?.country;
  const stateValue =
    formik?.values?.state?.length > 25
      ? formik?.values?.state?.slice(0, 25) + "..."
      : formik?.values?.state;

  useEffect(() => {
    GetCountries().then((result) => {
      setCountriesList(result);
    });
  }, []);

  useEffect(() => {
    GetState(233).then((result) => {
      setStateList(result);
    });
  }, []);

  return (
    <Modal
      isOpen={openModal}
      toggle={() => {
        formik.resetForm();
        toggle();
      }}
      centered
      fullscreen="sm"
      contentClassName={styles["modal_content"]}
      className={styles["container"]}
      wrapClassName={styles["modal_wrapper"]}
      backdropClassName={styles["modal-backdrop-style"]}
    >
      <ModalBody className={styles["modal_body"]}>
        <div>
          <p className={styles["heading"]}>Add a Location</p>
        </div>
        <div>
          <p className={styles["descriptiondiv"]}>
            A general area, such as a factory, warehouse, or store. Locations
            usually have addresses and must be specific to a country. Locations
            need names, which can be anything - they are just used internally.
            Example: "St Louis Bottling."
          </p>
        </div>
        <div className={styles["namebrandfields"]}>
          <div className={styles["inputFieldsDiv"]}>
            <Textfield
              name="name"
              id="name"
              onChange={formik.handleChange}
              value={formik.values.name}
              type="text"
              placeholder="Name*"
              className={styles["input_field_styles"]}
              error={formik?.errors?.name}
              touched={formik?.touched?.name}
            />
          </div>
          <div className={styles["inputFieldsDiv"]}>
            <Dropdown
              isOpen={brandsDropdownOpen}
              toggle={() => {
                setBrandsDropdownOpen(!brandsDropdownOpen);
              }}
            >
              <DropdownToggle
                className={`${styles["input_field_styles"]} ${styles["brand_dropdown"]}`}
              >
                {formik?.values?.brand || "Brand*"}
              </DropdownToggle>
              <DropdownMenu className={styles["menu_dropdown"]}>
                {(brandsFormattedData || [])?.map((brand, index) => {
                  return (
                    <DropdownItem
                      className={styles["dropdown_item"]}
                      onClick={() => {
                        formik.setFieldValue("brand", brand.name);
                        formik.setFieldValue("brandId", brand.id);
                      }}
                      key={index}
                    >
                      <div>{brand?.name || ""}</div>
                    </DropdownItem>
                  );
                })}
              </DropdownMenu>
            </Dropdown>
            {formik?.errors?.brandId && formik?.touched?.brandId && (
              <div className={styles["error"]}>{formik?.errors?.brandId}</div>
            )}
          </div>
        </div>
        <div>
          <Textfield
            name="globalLocationNumber"
            id="globalLocationNumber"
            onChange={formik.handleChange}
            value={formik.values.globalLocationNumber}
            error={formik?.errors?.globalLocationNumber}
            touched={formik?.touched?.globalLocationNumber}
            placeholder="Global Location Number"
            className={styles["input_field_styles"]}
          />
        </div>
        <div>
          <p className={styles["addressHeading"]}>Address</p>
        </div>
        <div className={styles["address_fields"]}>
          <div className={styles["addressfielddiv"]}>
            <div className={styles["inputFieldsDiv"]}>
              <Textfield
                name="addressLineOne"
                id="addressLineOne"
                onChange={formik.handleChange}
                value={formik.values.addressLineOne}
                error={formik?.errors?.addressLineOne}
                touched={formik?.touched?.addressLineOne}
                type="text"
                placeholder="Address Line 1"
                className={styles["input_field_styles"]}
              />
            </div>
            <div className={styles["inputFieldsDiv"]}>
              <Textfield
                name="addressLineTwo"
                id="addressLineTwo"
                onChange={formik.handleChange}
                value={formik.values.addressLineTwo}
                placeholder="Address Line 2"
                className={styles["input_field_styles"]}
              />
            </div>
          </div>
          <div className={styles["addressfielddiv"]}>
            <div className={styles["inputFieldsDiv"]}>
              <Dropdown
                isOpen={countryDropdownOpen}
                toggle={() => {
                  setCountryDropdownOpen(!countryDropdownOpen);
                }}
                disabled
              >
                <DropdownToggle
                  className={`${styles["input_field_styles"]} ${styles["brand_dropdown"]}`}
                >
                  {countryValue || "Country"}
                </DropdownToggle>
                <DropdownMenu className={styles["menu_dropdown"]}>
                  {(countriesList || [])?.map((country, index) => {
                    return (
                      <DropdownItem
                        className={styles["dropdown_item"]}
                        onClick={() => {
                          formik.setFieldValue("country", country.name);
                          formik.setFieldValue("state", "");
                          GetState(country.id)
                            .then((result) => {
                              setStateList(result);
                            })
                            .catch((error) => {
                              console.error("Error fetching states:", error);
                            });
                        }}
                        key={index}
                      >
                        <div>{country?.name || ""}</div>
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>
              {formik?.errors?.country && formik?.touched?.country && (
                <div className={styles["error"]}>{formik?.errors?.country}</div>
              )}
            </div>
            <div className={styles["inputFieldsDiv"]}>
              <Textfield
                name="city"
                id="city"
                onChange={formik.handleChange}
                value={formik.values.city}
                placeholder="City"
                className={styles["input_field_styles"]}
                error={formik?.errors?.city}
                touched={formik?.touched?.city}
              />
            </div>
          </div>
          <div className={styles["addressfielddiv"]}>
            <div className={styles["inputFieldsDiv"]}>
              <Dropdown
                isOpen={stateDropdown}
                toggle={() => {
                  setStateDropdown(!stateDropdown);
                }}
              >
                <DropdownToggle
                  className={`${styles["input_field_styles"]} ${styles["brand_dropdown"]}`}
                >
                  {stateValue || "State"}
                </DropdownToggle>
                <DropdownMenu className={styles["menu_dropdown"]}>
                  {(stateList || [])?.map((state, index) => {
                    return (
                      <DropdownItem
                        className={styles["dropdown_item"]}
                        onClick={() => {
                          formik.setFieldValue("state", state?.name);
                        }}
                        key={index}
                      >
                        <div>{state?.name || ""}</div>
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </Dropdown>

              {formik?.errors?.state && formik?.touched?.state && (
                <div className={styles["error"]}>{formik?.errors?.state}</div>
              )}
            </div>
            <div className={styles["inputFieldsDiv"]}>
              <Textfield
                name="zipCode"
                id="zipCode"
                onChange={formik.handleChange}
                value={formik.values.zipCode}
                placeholder="Zip Code"
                className={styles["input_field_styles"]}
                error={formik?.errors?.zipCode}
                touched={formik?.touched?.zipCode}
              />
            </div>
          </div>
        </div>
        <div className={styles["submit_btns"]}>
          <div className={styles["button_div"]}>
            <Button
              className={styles["button_style_cancel"]}
              onClick={() => {
                toggle();
              }}
              text="Cancel"
            >
              Cancel
            </Button>
          </div>
          <div className={styles["button_div"]}>
            <Button
              className={styles["button_style_add"]}
              onClick={() => {
                formik.handleSubmit();
              }}
              disabled={formik.isSubmitting}
              text={editLocationData?.id ? "Update Location" : "Add Location"}
            />
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

AddLocationModal.propTypes = {
  openModal: Proptypes.bool,
  toggle: Proptypes.func,
};

export default AddLocationModal;
